/**
 * KMar icon source — single switch between the new (Font Awesome) and the legacy
 * (raw-SVG) rendering method.
 *
 * Flip USE_FA_ICONS to `false` to instantly revert every picker and renderer to the
 * legacy `All` mapping. The keys are identical in both maps, so no consumer changes.
 *
 * NOTE: the `icons` export comes from kmar-icon-font/dist/icons-fa.js, which is not in
 * the published package yet — this branch relies on a locally-injected copy under
 * node_modules. Once kmar-icon-font is published with icons-fa.js and reinstalled, it
 * resolves normally and this file can stay as-is.
 */
import { All } from 'kmar-icon-font';
import { icons } from 'kmar-icon-font/dist/icons-fa.js';

export const USE_FA_ICONS = true;

export const kmarIcons = USE_FA_ICONS ? icons : All;
